import { POST_BUSINESS_PROFILE } from "../configs/routes.js";
import { buildBusinessProfilePayload } from "../utils/businessProfilePayload.js";
import api from "./api.js";

const putBusinessProfile = (businessData = {}) =>
  new Promise((resolve, reject) => {
    const payload = buildBusinessProfilePayload(businessData);
    api
      .put(POST_BUSINESS_PROFILE, payload)
      .then((response) => resolve(response.data))
      .catch((err) => reject(err.message));
  });

export default putBusinessProfile;
